export const OBTER_REVISTA = 'OBTER_REVISTA'
export const OBTER_MEDICAMENTO = 'OBTER_MEDICAMENTO'